import Vue from 'vue'
import Vuex from 'vuex';
import * as faceapi from 'face-api.js';


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    message:'',
    labeledFaceDescriptors:null,
    firstTimeMessage:true
  },
  mutations: {
    //synchronus way to store state in vuex
    updateMessage(state,payload){
      state.message = payload.message
    },
    initilizeFaceAPI: async function(){
      // console.log(faceapi.nets.tinyFaceDetector.loadFromUri('/models'))
        await faceapi.nets.tinyFaceDetector.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
        await faceapi.nets.faceLandmark68Net.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
        await faceapi.nets.faceRecognitionNet.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
        await faceapi.nets.ssdMobilenetv1.loadFromUri('https://cogneetive-face-detection.s3.amazonaws.com/faceapi-model/models');
        console.log('Initializing Modals video')
    }
  },
  async mounted() {
    try {
      const googleUser = await this.initGoogleAuth();  // Ensure this method is defined to initialize Google Auth
      let profile = googleUser.getBasicProfile();
      let info = {
        name: profile.getName(),
        profilePic: profile.getImageUrl(),
        email: profile.getEmail(),
      };
  
      localStorage.setItem("currentUser", JSON.stringify(info)); // Store user info in localStorage
      this.$store.commit('setCurrentUser', info); // Commit user info to Vuex store
      this.$router.push({ name: "Welcome" }); // Navigate to the Welcome page
      this.readOutLoud("Hello " + info.name); // Read out loud welcome message
    } catch (error) {
      console.error("Failed to authenticate with Google:", error);
    }
  },  
  actions: {
    //asynchronus always goes to actions
  },
  modules: {
  },
  getters:{
    //grab information and display anywhere in our app

  }
})
